import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Chip, Collapsible, CollapsibleItem, Icon } from 'react-materialize';
import {
  handleDeleteSale,
  handleFindProduct,
  handleGetDataInventory,
  handleGetSales,
} from '../../../tradeGlobalFunctions';
import WaitScreen from '../../../../../../Components/Globals/WaitScreen';
import { getFromStorage } from '../../../../../../services/auth';
import { Labels } from '../../../style';
import { Titulo } from '../style';
import { alerta, getScheduleData, updateScheduleData } from '../../../../../../services/funcoes';
import { DialogContent, DialogOptions, ContentCollapsible } from './styled';
import SaibRadioGroup from '../../../../../../Components/Globals/SaibRadioGroup';
import { IoMdEye, IoMdOptions } from 'react-icons/io';
import M from 'materialize-css';
import { ModalConfirm } from './ModalConfirm';
import { ComponentSearch } from './ComponentSearch';
import { Card } from './Card';

class OrderDirect extends Component {
  state = {
    status: 0,
    loading: false,
    products: [],
    productsOrder: [],
    typeOperation: 0,
    openDialogOptions: false,
    openFilters: false,
    ufs: [],
    citys: [],
    companys: [],
    productsOrigins: [],
  };

  componentDidMount = async () => {
    const { cliente, pesquisas, order, productsFilter } = this.props.history.location.state;
    await this.carregarVariaveisEstado();
    const scheduleData = await getScheduleData();

    let inProgress = scheduleData.ORDERS_DIRECT;
    if (inProgress) {
      inProgress = scheduleData.ORDERS_DIRECT.INPROGRESS;
    }

    if (order) {
      this.setState({
        productsOrder: order,
      });
    }

    if (productsFilter) {
      const ufs = [];
      const citys = [];
      const companys = [];
      const armazens = [];

      productsFilter.forEach((item) => {
        const existUf = ufs.find((e) => e === item.UF);
        const existCity = citys.find((e) => e === item.CIDADE);
        const existCompany = companys.find((e) => e === item.CODIGO);
        const existArmazen = armazens.find((e) => e === item.ESIN_ARMAZEM);

        if (!existUf) {
          ufs.push(item);
        }
        if (!existCity) {
          citys.push(item);
        }
        if (!existCompany) {
          companys.push(item);
        }
        if (!existArmazen) {
          armazens.push(item);
        }
      });

      let ufsChips = {};

      for (const uf of ufs) {
        let item = `${uf.UF}`;
        ufsChips[item] = null;
      }
      let citysChips = {};

      for (const uf of citys) {
        let item = `${uf.CIDADE}`;
        citysChips[item] = null;
      }
      let companysChips = {};

      for (const uf of companys) {
        let item = `${uf.NOME_FANTASIA}`;
        companysChips[item] = null;
      }

      let armazemsChips = {};
      for (const uf of armazens) {
        let item = `${uf.ESIN_ARMAZEM}`;
        armazemsChips[item] = null;
      }

      this.setState({
        ufsChips,
        citysChips,
        companysChips,
        armazemsChips,
      });
    }

    this.setState({
      cliente,
      pesquisas,
      loading: false,
      openDialogOptions: order && order.length > 0 ? false : true,
      inProgress,
      products: productsFilter || [],
    });
  };

  handleSearchProduct = async (searchProduct) => {
    if (!searchProduct) {
      alerta('Informe algum produto', 1);
      return;
    }
    this.setState({ loading: true });
    const sessao = getFromStorage();
    let res = await handleFindProduct(sessao.empresaId, sessao.codigoUsuario, searchProduct);
    if (res) {
      const productsOrigins = res;

      console.log(productsOrigins.filter(e => e.ESIN_EMP_ID !== 777))

      const ufs = [];
      const citys = [];
      const companys = [];
      const armazens = [];

      res.forEach((item) => {
        const existUf = ufs.find((e) => e === item.UF);
        const existCity = citys.find((e) => e === item.CIDADE);
        const existCompany = companys.find((e) => e === item.CODIGO);
        const existArmazen = armazens.find((e) => e === item.ESIN_ARMAZEM);

        if (!existUf) {
          ufs.push(item);
        }
        if (!existCity) {
          citys.push(item);
        }
        if (!existCompany) {
          companys.push(item);
        }
        if (!existArmazen) {
          armazens.push(item);
        }
      });

      let ufsChips = {};

      for (const uf of ufs) {
        let item = `${uf.UF}`;
        ufsChips[item] = null;
      }
      let citysChips = {};

      for (const uf of citys) {
        let item = `${uf.CIDADE}`;
        citysChips[item] = null;
      }
      let companysChips = {};

      for (const uf of companys) {
        let item = `${uf.NOME_FANTASIA}`;
        companysChips[item] = null;
      }

      let armazemsChips = {};
      for (const uf of armazens) {
        let item = `${uf.ESIN_ARMAZEM}`;
        armazemsChips[item] = null;
      }

      this.setState({
        products: res,
        productsOrigins,
        typeScreen: 1,
        ufsChips,
        citysChips,
        companysChips,
        armazemsChips,
      });
    } else {
      alerta('Não foi possível buscar os dados, verifique sua conexão com a internet', 2);
    }
    this.setState({ loading: false });
  };

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();

    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
    });
  };

  handleAddProduct = async (prod) => {
    const { productsOrder, productsOrigins, empresaAtiva } = this.state;

    const posExist = productsOrder.findIndex(
      (e) => e.PROD_ID === prod.PROD_ID && e.CODIGO === prod.CODIGO && e.SERIE === prod.SERIE
    );

    const productAux = productsOrigins.find(
      (e) => e.CODIGO_INTEGRACAOO === prod.CODIGO_INTEGRACAOO && e.ESIN_EMP_ID === empresaAtiva
    );

    if (!productAux) {
      alerta('O produto não está cadastrado na empresa atual');
      return;
    }

    if (posExist !== -1) {
      if (
        productsOrder[posExist].QTDE_PEDIDO + 1 <=
        productsOrder[posExist].QTDE_ORIGIN - productsOrder[posExist].QTDE_UTILIZADA
      ) {
        productsOrder[posExist].QTDE_PEDIDO += 1;
        productsOrder[posExist].QTDE -= 1;
        productsOrder[posExist].PROD_ID_VENDA = productAux?.PROD_ID || prod.PROD_ID;
        productsOrder[posExist].ESIN_ID_VENDA = productAux?.ESIN_ID !== -1 ? productAux?.ESIN_ID : null;
        productsOrder[posExist].ESIN_EMP_ID_VENDA = productAux?.ESIN_EMP_ID || prod.ESIN_EMP_ID;
        alerta('Produto adicionado', 1);
      }
    } else {
      prod.QTDE_PEDIDO = 1;
      prod.QTDE_ORIGIN = prod.QTDE;
      prod.QTDE -= 1;
      prod.PROD_ID_VENDA = productAux?.PROD_ID || prod.PROD_ID;
      prod.ESIN_ID_VENDA = productAux?.ESIN_ID !== -1 ? productAux?.ESIN_ID : null;
      prod.ESIN_EMP_ID_VENDA = productAux?.ESIN_EMP_ID || prod.ESIN_EMP_ID;
      productsOrder.push(prod);
      alerta('Produto adicionado', 1);
    }
    this.setState({ productsOrder });
  };

  handleAddProductConsignado = async (prod) => {
    const { productsOrder, productsOrigins } = this.state;

    const currentProduct = productsOrigins.findIndex(
      (e) => e.PROD_ID === prod.PROD_ID && e.ESIN_ID === prod.ESIN_ID && e.LOTE === prod.LOTE && e.SERIE === prod.SERIE
    );

    if (currentProduct !== -1 && productsOrigins[currentProduct].QTDE - 1 >= 0) {
      productsOrigins[currentProduct].QTDE = productsOrigins[currentProduct].QTDE - 1;

      let newRequest = productsOrder?.find((e) => e.ESIN_ID === prod.ESIN_ID);

      if (newRequest) {
        const pos = productsOrder?.findIndex((e) => e.ESIN_ID === prod.ESIN_ID);
        const lido = productsOrder[pos].QTDE_LIDO + 1;
        productsOrder[pos].QTDE_LIDO = lido;
        productsOrder[pos].QTDE_ORDER = lido;
      } else {
        newRequest = { ...productsOrigins[currentProduct] };
        newRequest.QTDE_LIDO = 1;
        newRequest.QTDE_ORDER = 1;
        productsOrder.push(newRequest);
        alerta('Produto adicionado ao pedido', 1);
      }
      this.setState({ productsOrigins, productsOrder });
    }
  };

  handleRemoveProduct = (prod) => {
    let { productsOrder } = this.state;

    const pos = productsOrder.findIndex(
      (e) => e.PROD_ID === prod.PROD_ID && e.CLI_ID === prod.CLI_ID && e.SERIE === prod.SERIE
    );

    if (pos !== -1) {
      if (productsOrder[pos].QTDE + 1 <= productsOrder[pos].QTDE_ORIGIN) {
        productsOrder[pos].QTDE_PEDIDO -= 1;
        productsOrder[pos].QTDE += 1;
      }

      if (productsOrder[pos].QTDE_PEDIDO === 0) {
        productsOrder.splice(pos, 1);
      }
    }
    this.setState({ productsOrder });
  };

  handleRemoveProductConsignado = async (prod, index) => {
    const { productsOrder, products } = this.state;

    if (productsOrder[index].QTDE_LIDO > 0) {
      const pos = products?.findIndex((e) => e.ESIN_ID === prod.ESIN_ID);
      if (pos !== -1) {
        products[pos].QTDE += 1;
        products[pos].QTDE_ORDER -= 1;
      }
      productsOrder[index].QTDE_LIDO -= 1;

      if (productsOrder[index].QTDE_LIDO === 0) {
        productsOrder.splice(index, 1);
      }

      this.setState({ products, productsOrder });
    }
  };

  handleSendOrder = async (view) => {
    const { cliente, pesquisas, productsOrder, typeOperation, products, productsOrigins } = this.state;

    this.setState({ loading: true });

    const companys = [];
    const scheduleData = await getScheduleData();
    const sessao = getFromStorage();

    productsOrder.forEach((item) => {
      let currentCustomer = scheduleData.CLI_IN_PROGRESS;
      if (!currentCustomer) {
        currentCustomer = scheduleData?.CLIENTES?.find((e) => e.SEQ_PADRAO === scheduleData.cliAtendimento)?.CLI_ID;

        if (!currentCustomer) {
          currentCustomer = scheduleData?.CLIENTES?.find((e) => e.CLI_ID === scheduleData.cliAtendimento)?.CLI_ID;

          if (!currentCustomer) {
            alerta('Não foi possível encontrar o cliente atual', 2);
            this.setState({ loading: false });
            return;
          }
        }
      }

      const exist = companys.findIndex((e) => e.id === (item.CLI_ID || currentCustomer));

      if (exist !== -1) {
        companys[exist] = {
          name: item.NOME_FANTASIA,
          emp: item.ESIN_EMP_ID || sessao.empresaId,
          id: item.CLI_ID || currentCustomer,
          products: [...(companys[exist].products || []), item],
        };
      } else {
        companys.push({
          name: item.NOME_FANTASIA,
          emp: item.ESIN_EMP_ID || sessao.empresaId,
          id: item.CLI_ID || currentCustomer,
          products: [item],
        });
      }
    });

    this.props.history.push({
      pathname: '/NewOrderDirect',
      state: {
        cliente,
        pesquisas,
        companys,
        statusVenda: typeOperation,
        order: productsOrder,
        view,
        productsFilter: products,
        productsOrigins,
      },
    });

    this.setState({ loading: false });
  };

  handleTypeOrder = async (type) => {
    try {
      this.setState({ loading: true });
      this.setState({ typeOperation: type, openDialogOptions: false });
      if (type === 3) {
        const { cliente, pesquisas } = this.props.history.location.state;
        const scheduleData = await getScheduleData();
        let inventory = scheduleData.CONFERENCE;

        if (inventory) {
          inventory = scheduleData.CONFERENCE.INVENTORY;
        }

        if (!inventory || inventory.length === 0) {
          const sessao = getFromStorage();
          this.setState({
            loading: true,
          });
          inventory = await handleGetDataInventory(sessao.empresaId, sessao.codigoUsuario, cliente.CLI_ID);
        }

        if (!inventory) {
          alerta('Não foi possível buscar os dados, verifique sua conexão com a internet', 2);
          this.setState({
            loading: false,
          });
          this.props.history.push({
            pathname: '/AdminModule',
            state: {
              cliente: cliente,
              pesquisas: pesquisas,
            },
          });
          return;
        }

        this.setState({
          products: inventory,
          productsOrigins: inventory,
          loading: false,
        });
      } else {
        this.setState({
          products: [],
          productsOrigins: [],
        });
      }
    } catch (error) {
    } finally {
      this.setState({ loading: false });
    }
  };

  handleEditOrder = async (item, index, view) => {
    const { empresaAtiva, usuarioAtivo, cliente, pesquisas, inProgress } = this.state;
    const scheduleData = await getScheduleData();
    this.setState({ loading: true });
    const res = await handleGetSales(empresaAtiva, usuarioAtivo, item.ATD_ID);
    this.setState({ loading: false });

    if (res && res.length !== 0) {
      this.props.history.push({
        pathname: '/EditOrderDirect',
        state: {
          cliente,
          pesquisas,
          order: res,
          pos: index,
        },
      });
    } else {
      inProgress[index].ATD_FLAG_SITUACAO = 'B';
      scheduleData.ORDERS_DIRECT.INPROGRESS = inProgress;
      await updateScheduleData(scheduleData);
      this.setState({ inProgress });
      alerta('Não é possível editar esse pedido', 2);
      return;
    }
  };

  handleDeleteOrder = async (id, index) => {
    let { empresaAtiva, usuarioAtivo, inProgress } = this.state;
    this.setState({ loading: true });
    const res = await handleDeleteSale(empresaAtiva, usuarioAtivo, id);
    this.setState({ loading: false });

    if (res) {
      inProgress = inProgress.filter((e) => e.ATD_ID !== id);

      this.setState({ inProgress });
      const scheduleData = await getScheduleData();
      scheduleData.ORDERS_DIRECT.INPROGRESS = inProgress;
      await updateScheduleData(scheduleData);
    }
  };

  onChangeSelectCitys = () => {
    if (document.getElementById('cityChips') !== undefined) {
      let dados = M.Chips.getInstance(document.getElementById('cityChips'));
      let citysSelects;
      const namesCitys = [];

      if (dados !== undefined) {
        citysSelects = dados.chipsData;
        if (citysSelects && citysSelects?.length > 0) {
          for (let promotor of citysSelects) {
            let name = promotor.tag.split('-')[0];
            namesCitys.push(name);
          }
        }

        this.setState({
          citysSelects,
          namesCitys,
        });
      }
    }
  };

  onChangeSelectUf = () => {
    if (document.getElementById('ufsChips') !== undefined) {
      let dados = M.Chips.getInstance(document.getElementById('ufsChips'));
      let ufsSelects;
      const namesUfs = [];

      if (dados !== undefined) {
        ufsSelects = dados.chipsData;
        if (ufsSelects && ufsSelects?.length > 0) {
          for (let promotor of ufsSelects) {
            let name = promotor.tag.split('-')[0];
            namesUfs.push(name);
          }
        }

        this.setState({
          ufsSelects,
          namesUfs,
        });
      }
    }
  };

  onChangeSelectCompany = () => {
    if (document.getElementById('companysChips') !== undefined) {
      let dados = M.Chips.getInstance(document.getElementById('companysChips'));
      let companysSelects;
      let namesCompanys = [];

      if (dados !== undefined) {
        companysSelects = dados.chipsData;
        if (companysSelects && companysSelects?.length > 0) {
          for (let promotor of companysSelects) {
            let name = promotor.tag.split('-')[0];
            namesCompanys.push(name);
          }
        }

        this.setState({
          companysSelects,
          namesCompanys,
        });
      }
    }
  };

  onChangeSelectArmazem = () => {
    if (document.getElementById('armazemChips') !== undefined) {
      let dados = M.Chips.getInstance(document.getElementById('armazemChips'));
      let armazemSelects;
      let namesArmazem = [];

      if (dados !== undefined) {
        armazemSelects = dados.chipsData;

        if (armazemSelects && armazemSelects?.length > 0) {
          for (let promotor of armazemSelects) {
            let name = promotor.tag.startsWith('-') ? '-' + promotor.tag.split('-')[1] : promotor.tag.split('-')[0];
            namesArmazem.push(name);
          }
        }

        this.setState({
          armazemSelects,
          namesArmazem,
        });
      }
    }
  };

  removeAcentos = (word) => {
    return word
      .normalize('NFD') // Normaliza os caracteres para decompor acentos
      .replace(/[\u0300-\u036f]/g, ''); // Remove os sinais de acentuação
  };

  handleBackPage = () => {
    const { cliente, pesquisas, productsOrder } = this.state;
    if (productsOrder && productsOrder.length > 0) {
      this.setState({ openModalConfirm: true });
    } else {
      this.props.history.push({
        pathname: '/AdminModule',
        state: {
          cliente: cliente,
          pesquisas: pesquisas,
        },
      });
    }
  };

  render() {
    const {
      cliente,
      pesquisas,
      loading,
      products,
      productsOrder,
      openDialogOptions,
      typeOperation,
      openFilters,
      ufsChips,
      citysChips,
      companysChips,
      citysSelects,
      ufsSelects,
      companysSelects,
      armazemSelects,
      armazemsChips,
      namesCitys,
      namesUfs,
      namesCompanys,
      namesArmazem,
      optionFilterSituation,
      openModalConfirm,
    } = this.state;

    let productsFilter = JSON.parse(JSON.stringify(products));
    if (namesCitys && namesCitys.length > 0) {
      productsFilter = productsFilter.filter((e) => namesCitys.includes(this.removeAcentos(e.CIDADE)));
    }

    if (namesUfs && namesUfs.length > 0) {
      productsFilter = productsFilter.filter((e) => namesUfs.includes(this.removeAcentos(e.UF)));
    }
    if (namesCompanys && namesCompanys.length > 0) {
      productsFilter = productsFilter.filter((e) => namesCompanys.includes(this.removeAcentos(e.NOME_FANTASIA)));
    }

    if (namesArmazem && namesArmazem.length > 0) {
      productsFilter = productsFilter.filter((e) => namesArmazem.includes(e.ESIN_ARMAZEM));
    }

    if (optionFilterSituation === '1') {
      productsFilter = productsFilter.filter((e) => e.LOCALIZACAO === 'EM_ESTOQUE');
    } else if (optionFilterSituation === '2') {
      productsFilter = productsFilter.filter((e) => e.LOCALIZACAO === 'CONSIGNADO');
    }

    return (
      <>
        <WaitScreen loading={loading} />

        <Titulo
          style={{
            justifyContent: 'flex-start',
            paddingLeft: '15px',
            top: '0px',
            zIndex: '2',
          }}
        >
          <button
            style={{ cursor: 'pointer', color: 'white' }}
            className="waves-effect waves-light saib-button is-cancel"
            onClick={this.handleBackPage}
          >
            <Icon className="modal-close">arrow_back</Icon>
          </button>
          {typeOperation === 1 && (
            <p style={{ position: 'unset', top: 'unset', width: '100%' }}>Venda direta (venda)</p>
          )}
          {typeOperation === 0 && (
            <p style={{ position: 'unset', top: 'unset', width: '100%' }}>Venda direta (consignado)</p>
          )}
          {typeOperation === 2 && (
            <p style={{ position: 'unset', top: 'unset', width: '100%' }}>Venda direta (bonificação)</p>
          )}
          {typeOperation === 3 && <p style={{ position: 'unset', top: 'unset', width: '100%' }}>Venda de consignado</p>}
        </Titulo>
        <section style={{ width: '100%', padding: '10px 5px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '5px',
              width: '100%',
            }}
          >
            <Button
              onClick={() => this.setState({ openDialogOptions: true })}
              className="waves-effect waves-light saib-button is-primary"
              disabled={openDialogOptions || (productsOrder && productsOrder.length > 0)}
            >
              Alterar o tipo de venda
            </Button>
            {products && products.length > 0 && (
              <Button
                onClick={() => this.setState({ openFilters: !openFilters })}
                className="waves-effect waves-light saib-button is-primary"
              >
                <IoMdOptions style={{ marginRight: '0.3rem' }} />
                Filtrar produtos
              </Button>
            )}
          </div>
          <ComponentSearch
            productsFilter={productsFilter}
            handleSearchProduct={(res) => this.handleSearchProduct(res)}
            cleanForm={() => {
              this.setState({
                products: [],
                productsOrigins: [],
                ufsChips: {},
                citysChips: {},
                companysChips: {},
                armazemsChips: {},
              });
            }}
          />

          {productsOrder && productsOrder.length > 0 && (
            <>
              <ContentCollapsible className="collapsibleQuestionManager">
                <Collapsible accordion className="collapsibleQuestionManager">
                  <CollapsibleItem
                    className="collapsibleQuestionManagerItem"
                    expanded={false}
                    icon={
                      <>
                        <p className="material-icons plus">add_circle_outline</p>

                        <p className="material-icons minus">remove_circle_outline</p>
                      </>
                    }
                    header={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          padding: '5px',
                          gap: '5px',
                          background: '#bf1f7c',
                          color: '#fff',
                          borderRadius: '5px',
                        }}
                      >
                        <span>{productsOrder.length} produtos no pedido</span>
                      </div>
                    }
                    node="div"
                  >
                    {productsOrder.map((item, index) => (
                      <div
                        key={item.ESIN_ID || `${item.PROD_ID}_${item.CODIGO}_${item.LOTE}_${index}`}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          gap: '0.5rem',
                          borderBottom: '1px solid #ccc',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                            {item.PRODUTO || item.PROD_DESCR}
                          </span>
                          <span style={{ fontWeight: '500', fontSize: '1rem', marginTop: '-2px' }}>
                            {item.NOME_FANTASIA}
                          </span>
                          <span style={{ fontWeight: '400', fontSize: '0.9rem', marginTop: '-2px', color: '#4d4d4d' }}>
                            {item.CLI_ID === -1 ? 'Venda' : 'Devolução'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ fontWeight: '500', fontSize: '1.2rem' }}>
                            Qtde: {item.QTDE_PEDIDO || item.QTDE_LIDO}
                          </span>
                          <button
                            onClick={() => {
                              if (item.QTDE_LIDO) {
                                this.handleRemoveProductConsignado(item, index);
                              } else {
                                this.handleRemoveProduct(item);
                              }
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              background: '#8E44AD',
                              color: '#fff',
                              borderRadius: '4px',
                              border: 'none',
                              marginRight: '0.3rem',
                              padding: '0.2rem',
                            }}
                          >
                            <Icon>remove</Icon>
                          </button>
                        </div>
                      </div>
                    ))}
                  </CollapsibleItem>
                </Collapsible>
              </ContentCollapsible>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  width: '100%',
                  marginTop: '-4px',
                }}
              >
                <Button
                  onClick={() => this.handleSendOrder(true)}
                  style={{
                    gap: '0.3rem',
                    margin: '0.6rem 0.2rem 0.2rem',
                    width: '100%',
                    background: '#bf1f7c',
                  }}
                  className="waves-effect waves-light saib-button is-primary"
                >
                  Visualizar
                  <IoMdEye size={20} />
                </Button>
                <Button
                  onClick={() => this.handleSendOrder(false)}
                  style={{
                    gap: '0.3rem',
                    margin: '0.6rem 0.2rem 0.2rem',
                    width: '100%',
                    background: '#bf1f7c',
                  }}
                  className="waves-effect waves-light saib-button is-primary"
                >
                  Enviar pedido
                  <Icon className="modal-close">send</Icon>
                </Button>
              </div>
            </>
          )}

          {productsFilter.map((prod) => (
            <Card
              key={`${prod.ESIN_ID}${prod.PROD_ID}_${prod.CODIGO}_${prod.SERIE}`}
              handleAddProduct={this.handleAddProduct}
              prod={prod}
              handleAddProductConsignado={this.handleAddProductConsignado}
            />
          ))}

          {(!productsFilter || (productsFilter && productsFilter.length === 0)) && (
            <Labels style={{ margin: '0.4rem', fontSize: '1.2rem', color: '#000' }}>Nenhum produto encontrado</Labels>
          )}
        </section>

        {openDialogOptions && (
          <DialogOptions>
            <DialogContent>
              <h2>Escolha a opção de pedido</h2>
              <Button
                onClick={() => this.handleTypeOrder(3)}
                className="waves-effect waves-light saib-button is-primary"
              >
                Venda consignado
              </Button>
              <Button
                onClick={() => this.handleTypeOrder(1)}
                className="waves-effect waves-light saib-button is-primary"
              >
                Venda
              </Button>
              <Button
                onClick={() => this.handleTypeOrder(0)}
                className="waves-effect waves-light saib-button is-primary"
              >
                Consignado
              </Button>
              <Button
                onClick={() => this.handleTypeOrder(2)}
                className="waves-effect waves-light saib-button is-primary"
              >
                Bonificação
              </Button>
            </DialogContent>
          </DialogOptions>
        )}

        {openModalConfirm && (
          <ModalConfirm
            handleConfirm={() => {
              this.props.history.push({
                pathname: '/AdminModule',
                state: {
                  cliente: cliente,
                  pesquisas: pesquisas,
                },
              });
            }}
            handleCancel={() => this.setState({ openModalConfirm: false })}
          />
        )}

        {openFilters && (
          <DialogOptions>
            <DialogContent>
              <SaibRadioGroup
                valueItems={'"1","2", "3"'}
                classNameItems={'"estoque", "consignado", "all"'}
                textItems={'"Em estoque","Consignado", "Todos"'}
                idItems={'"estoqueId", "consignadoId", "allId"'}
                classNameRadio="filterSituation"
                flexDirectionRadio="row"
                disabledRadio="false"
                defaultCheckedId={optionFilterSituation || 'allId'}
                onChange={async (value) => {
                  this.setState({
                    optionFilterSituation: value,
                  });
                }}
              />
              <div flex={3} className="divDetailGerente">
                <Labels>Cidade</Labels>
                <Chip
                  id="cityChips"
                  className="cityChips"
                  close={false}
                  closeIcon={<Icon className="close">close</Icon>}
                  options={{
                    data: citysSelects !== undefined ? citysSelects : [],
                    onChipAdd: this.onChangeSelectCitys,
                    onChipDelete: this.onChangeSelectCitys,
                    autocompleteOptions: {
                      data: citysChips,
                      limit: 1,
                      onAutocomplete: function noRefCheck() {},
                    },
                  }}
                />
              </div>
              <div flex={3} className="divDetailGerente">
                <Labels>UF</Labels>
                <Chip
                  id="ufsChips"
                  className="ufsChips"
                  close={false}
                  closeIcon={<Icon className="close">close</Icon>}
                  options={{
                    data: ufsSelects !== undefined ? ufsSelects : [],
                    onChipAdd: this.onChangeSelectUf,
                    onChipDelete: this.onChangeSelectUf,
                    autocompleteOptions: {
                      data: ufsChips,
                      limit: 1,
                      onAutocomplete: function noRefCheck() {},
                    },
                  }}
                />
              </div>
              <div>
                <Labels>Empresa</Labels>
                <Chip
                  id="companysChips"
                  className="companysChips"
                  close={false}
                  closeIcon={<Icon className="close">close</Icon>}
                  options={{
                    data: companysSelects !== undefined ? companysSelects : [],
                    onChipAdd: this.onChangeSelectCompany,
                    onChipDelete: this.onChangeSelectCompany,
                    autocompleteOptions: {
                      data: companysChips,
                      limit: 1,
                      onAutocomplete: function noRefCheck() {},
                    },
                  }}
                />
              </div>
              <div>
                <Labels>Armazém</Labels>
                <Chip
                  id="armazemChips"
                  className="armazemChips"
                  close={false}
                  closeIcon={<Icon className="close">close</Icon>}
                  options={{
                    data: armazemSelects !== undefined ? armazemSelects : [],
                    onChipAdd: this.onChangeSelectArmazem,
                    onChipDelete: this.onChangeSelectArmazem,
                    autocompleteOptions: {
                      data: armazemsChips,
                      limit: 1,
                      onAutocomplete: function noRefCheck() {},
                    },
                  }}
                />
              </div>
              <Button
                onClick={() => this.setState({ openFilters: false })}
                className="waves-effect waves-light saib-button is-primary"
              >
                Filtrar produtos
              </Button>
            </DialogContent>
          </DialogOptions>
        )}
      </>
    );
  }
}

export default withRouter(OrderDirect);
